import { toast } from 'sonner'
import { formatPath, type PathSegment } from '../lib/json-path'

/** Copies `{{ <path> }}` to the clipboard. */
export async function copyBindingPath(path: string) {
  const text = `{{ ${path} }}`
  try {
    await navigator.clipboard.writeText(text)
    toast.success('Binding copied', { description: text })
  } catch {
    toast.error('Couldn’t access the clipboard', { description: text })
  }
}

/** Copies `{{ key.path }}` to the clipboard. */
export async function copyBinding(alias: string, segments: readonly PathSegment[]) {
  return copyBindingPath(formatPath(alias, segments))
}
